import * as userMgtConstant from './actionTypes';
import request from './Request';
import constants from '../../config/constants';
import moment from 'moment';
import {utils,writeFile} from 'xlsx';
import {postLogoutRedirectUri,msalConfig } from '../../config/msalConfig';

export const getUserMgtList = (limit,page,filter, search) => {
  // const businessId = filter?.filterByBusinessUnit?.map(item => item.value) || '';
const location = filter?.filterByBusinessUnitLocation !== "" ? filter?.filterByBusinessUnitLocation?.map(item => item.value) : '';
let parameters = {
  limit: limit,
  page:page,
  search: search || "",
}

  return (dispatch) => {
    dispatch({
      type: userMgtConstant.FETCH_USER_MGT_LIST
    });
    request({
        method: 'get',
        headers:{
          "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
        },
        url: `${constants.BASE_URL}user/list?filterByBusinessUnit=${filter?.businessId || ""}&filterByBusinessUnitLocation=${location || ""}&filterByStatus=${filter?.filterByStatus || ""}&filterByName=${filter?.filterByName || ""}`,
        params: parameters

    })
      .then((response) => {
        dispatch({
          type: userMgtConstant.FETCH_USER_MGT_LIST_SUCCESS,
          payload: response.data
        });
      })
      .catch((error) => {
        dispatch({
          type: userMgtConstant.FETCH_USER_MGT_LIST_FAILURE,
          payload:error?.response?.data
        });
      })
  }

}

export const getUserMgtDetails = (payload) => {
    return (dispatch) => {
      dispatch({
        type: userMgtConstant.FETCH_USER_MGT_DETAILS
      });
        request({
            method: 'get',
            headers:{
              "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
            },
            url:`${constants.BASE_URL}charitableEvent/view?charitableEventId=${payload}`,
        })
        .then((response) => {
          dispatch({
            type: userMgtConstant.FETCH_USER_MGT_DETAILS_SUCCESS,
            payload: response
          });
        })
        .catch((error) => {
          dispatch({
            type: userMgtConstant.FETCH_USER_MGT_DETAILS_FAILURE,
            payload:error?.response?.data
          });
        })
    }
  
  }
  export const getBUnitFilterDetails = (payload) => {
    const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));

      return (dispatch) => {
        dispatch({
          type: userMgtConstant.FETCH_USER_MGT_FILTER_LIST
        });
          request({
              method: 'get',
              headers:{
                "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
              },
              url:`${constants.BASE_URL}lov/businessUnitLocation/${userDetails?.userId}`,
          })
          .then((response) => {
            dispatch({
              type: userMgtConstant.FETCH_USER_MGT_FILTER_LIST_SUCCESS,
              payload: response.data
            });
          })
          .catch((error) => {
            dispatch({
              type: userMgtConstant.FETCH_USER_MGT_FILTER_LIST_FAILURE,
              payload:error?.response?.data
            });
          })
      }
    
    }
    export const getBUnitLov = (payload) => {
        return (dispatch) => {
          dispatch({
            type: userMgtConstant.FETCH_SELF_REG_FILTER_LIST
          });
            request({
                method: 'get',
                headers:{
                  "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
                },
                url:`${constants.BASE_URL}lov/businessLocation`,
            })
            .then((response) => {
              dispatch({
                type: userMgtConstant.FETCH_SELF_REG_FILTER_LIST_SUCCESS,
                payload: response.data
              });
            })
            .catch((error) => {
              dispatch({
                type: userMgtConstant.FETCH_SELF_REG_FILTER_LIST_FAILURE,
                payload:error?.response?.data
              });
            })
        }
      
      }

    export const getRolesLov = (payload) => {
      const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));

      return (dispatch) => {
          request({
              method: 'get',
              headers:{
                "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
              },
              url:`${constants.BASE_URL}lov/roles/${userDetails?.userId}`,
          })
          .then((response) => {
            dispatch({
              type: userMgtConstant.FETCH_ROLES_LOV_SUCCESS,
              payload: response.data
            });
          })
          .catch((error) => {
            dispatch({
              type: userMgtConstant.FETCH_ROLES_LOV_FAILURE,
              payload:error?.response?.data
            });
          })
      }
    
    }
  export const createNewUserMgt = (payload) => {
  
  return (dispatch) => {
    dispatch({
      type: userMgtConstant.CREATE_USER_MGT
    });

    request({
        method: 'post',
        url: `${constants.BASE_URL}user/create`,
        headers:{
          "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
        },
        data : payload 
    })
    .then((response) => {
      if(response?.data && response.data.data && payload?.isSelfRegistration ){
        window.sessionStorage.setItem('userInfo', JSON.stringify(response.data.data))
        window.localStorage.setItem('userInfo', JSON.stringify(response.data.data))
      }
        dispatch({
          type: userMgtConstant.CREATE_USER_MGT_SUCCESS,
          payload: response.data
        });
    
    }).catch((error) => {
      dispatch({
        type: userMgtConstant.CREATE_USER_MGT_FAILURE,
        payload:error?.response?.data
      });
    });
  }

}
export const updateNewUserMgt = (payload) => {
  return (dispatch) => {
    dispatch({
      type: userMgtConstant.UPDATE_USER_MGT
    });

    request({
        method: 'post',
        headers:{
          "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
        },
        url: `${constants.BASE_URL}user/update`,
        data : payload 
    })
  .then((response) => {
      dispatch({
        type: userMgtConstant.UPDATE_USER_MGT_SUCCESS,
        payload: response.data
      });
  }).catch((error) => {
    dispatch({
      type: userMgtConstant.UPDATE_USER_MGT_FAILURE,
      payload:error?.response?.data
    });
  });
}

}
export const deleteUserMgt = (data) => {
  return (dispatch) => {
      dispatch({
        type: userMgtConstant.DELETE_USER_MGT,
      });
     
      request({
          method: 'post',
          headers:{
            "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
          },
          url:`${constants.BASE_URL}user/delete/${data.id}`,   
          data: data
      })
      .then((response) => {
        dispatch({
          type: userMgtConstant.DELETE_USER_MGT_SUCCESS,
          payload: response.data
        });
      })
      .catch((error) => {
        dispatch({
          type: userMgtConstant.DELETE_USER_MGT_FAILURE,
          payload: error?.response?.data
        });
      })

  }
}


export const getProfileDetails =  (dataObj, msalIns) => {
  return (dispatch) => {
    dispatch({
      type: userMgtConstant.GET_USER_MGT,
    });
      request({
          method: 'post',
          headers:{
            "Authorization": `Bearer ${dataObj?.token}`
          },
          url:`${constants.BASE_URL}user/login`,   
          data: {
            email: dataObj?.email,
            userName: dataObj?.userName
          }
      })
      .then((response) => {
        window.sessionStorage.setItem('userInfo', JSON.stringify(response.data.data))
        window.localStorage.setItem('userInfo', JSON.stringify(response.data.data))

        if(response?.data && response.data.data ){
          window.sessionStorage.setItem("tokenDetail", dataObj?.token)
          // window.sessionStorage.setItem("language", response.data.data.langPreference)
          window.localStorage.setItem("tokenDetail", dataObj?.token)
          window.sessionStorage.setItem('userInfo', JSON.stringify(response.data.data))
          window.localStorage.setItem('userInfo', JSON.stringify(response.data.data))
        }
        dispatch({
          type: userMgtConstant.GET_USER_MGT_SUCCESS,
          payload: response.data
        });
      })
      .catch((error) => {
        // setCookie('isLoginFailed',true);
        const currentAccount = msalIns.getAccountByHomeId(JSON.parse(window.sessionStorage.getItem('home_account'))?.homeAccountId);
        msalIns.logout({
            account: currentAccount,
            postLogoutRedirectUri: postLogoutRedirectUri.redirectUri,
            authority: msalConfig.auth.authority
          });
          window.sessionStorage.clear();
        dispatch({
          type: userMgtConstant.GET_USER_MGT_FAILURE,
          payload: error?.response?.data
        });
      })
    }
}



export const updateFirstTimeLogin =  async () => {
  const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));
      request({
          method: 'post',
          headers:{
            "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
          },
          url:`${constants.BASE_URL}user/firstlogin/${userDetails?.userId}`, 
      })
      .then((response) => {
        if(response?.data && response?.data.status === 200){
          const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));
          userDetails.isFirstTimeLogin = false;
          window.localStorage.setItem("userInfo",JSON.stringify(userDetails))
        }
      })
      .catch((error) => {
      
      })
}
export const tokenAuthCheck = () => {
  return (dispatch) => {
    request({
        method: 'get',
        headers:{
          "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}` || "",
        },
        url:`${constants.BASE_URL}token`,   
    })
    .then((response) => {
      dispatch({
        type: userMgtConstant.TOKEN_AUTH_SUCCESS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: userMgtConstant.TOKEN_AUTH_SUCCESS,
        payload: error?.response?.data
      });
    })
  }
}
export const forgotMyPasswordReset = (email) => {
  return (dispatch) => {
    request({
        method: 'post',
        headers:{
          "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}` || ""
        },
        url:`${constants.BASE_URL}user/triggerResetPwdMail/${email}`,   
    })
    .then((response) => {
      dispatch({
        type: userMgtConstant.RESET_MY_FORGOT_PWD_SUCCESS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: userMgtConstant.RESET_MY_FORGOT_PWD_FAILURE,
        payload: error?.response?.data
      });
    })
  }
}
export const confirmThePasswordReset = (payloadData) => {
  return (dispatch) => {
    request({
        method: 'post',
        headers:{
          "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}` || ""
        },
        url:`${constants.BASE_URL}user/changepwd`,  
        data: {
          uid: payloadData?.uid,
          pwd: payloadData?.confirmpassword
        }   
    })
    .then((response) => {
      dispatch({
        type: userMgtConstant.RESET_MY_PWD_SUCCESS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: userMgtConstant.RESET_MY_PWD_FAILURE,
        payload: error?.response?.data
      });
    })
  }
}
export const triggerMail = (payload) => {
  
  return (dispatch) => {
    dispatch({
      type: userMgtConstant.TRIGGER_MAIL
    });

    request({
        method: 'post',
        url: `${constants.BASE_URL}user/triggerMail`,
        headers:{
          "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
        },
        data : payload 
    })
    .then((response) => {
        dispatch({
          type: userMgtConstant.TRIGGER_MAIL_SUCCESS,
          payload: response.data
        });
    
    }).catch((error) => {
      dispatch({
        type: userMgtConstant.TRIGGER_MAIL_FAILURE,
        payload:error?.response?.data
      });
    });
  }

}
export function exportReport(filter) {
  
  return (dispatch) => {
    dispatch({
      type: userMgtConstant.EXPORT_USER_DATA,
    });
    request({
      method: 'get',
      headers:{
        "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
      },
      url: `${constants.BASE_URL}user/export?filterByBusinessUnit=${filter.businessId}&filterByBusinessUnitLocation=${filter.location}&filterByStatus=${filter.filterByStatus}`,
    }).then((response) => {
    const wb = utils.book_new();
    const ws = utils.json_to_sheet([{"Export Date":new Date()}])
    utils.sheet_add_json(ws,[{'Total Records' : response.data.totalCount}],{origin: "A5"})
    utils.sheet_add_json(ws,response?.data?.data?.map((item) => {
      const csvdata = {...item};
      return csvdata;
    }),{origin: "A8"})
    utils.book_append_sheet(wb,ws, 'Sheet1');
    writeFile(wb,`user-report.xlsx`);
    })
      .catch((error) => {
        dispatch({
          type: userMgtConstant.EXPORT_USER_DATA_FAILURE,
          payload: error
        });
      })

  }
}

export const getAdminDetails = (payload) => {
  const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));

    return (dispatch) => {
      dispatch({
        type: userMgtConstant.GET_ADMIN_DETAILS
      });
        request({
            method: 'get',
            headers:{
              "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
            },
            
            url:`${constants.BASE_URL}user/profile/${userDetails?.userId}`,
        })
        .then((response) => {
          dispatch({
            type: userMgtConstant.GET_ADMIN_DETAILS_SUCCESS,
            payload: response.data
          });
        })
        .catch((error) => {
          dispatch({
            type: userMgtConstant.GET_ADMIN_DETAILS_FAILURE,
            payload:error?.response?.data
          });
        })
    }
  
  }
  export const updateAdminDetails = (payload) =>  {

    return (dispatch) => {
      dispatch({
        type: userMgtConstant.UPDATE_ADMIN_DETAILS
      });
  
      request({
          method: 'post',
          url: `${constants.BASE_URL}user/profile`,
          headers:{
            "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
          },
          data : payload 
      })
      .then((response) => {
          dispatch({
            type: userMgtConstant.UPDATE_ADMIN_DETAILS_SUCCESS,
            payload: response.data
          });
      
      }).catch((error) => {
        dispatch({
          type: userMgtConstant.UPDATE_ADMIN_DETAILS_FAILURE,
          payload:error?.response?.data
        });
      });
    }
  
  }